import React from "react";
import { Form, Input, Row, Col } from "antd";
import { idValidator } from "../../../../utils/validator";

const { TextArea } = Input;

const IdentificationSection = () => {
  return (
    <div className="p-5">
      <Row gutter={[16, 16]}>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="govtID"
            label="Government ID"
            rules={[{ validator: idValidator }]}
          >
            <Input placeholder="Government ID" maxLength={30} />
          </Form.Item>
        </Col>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="ssn"
            label="Social Security Number"
            rules={[{ validator: idValidator }]}
          >
            <Input
              placeholder="Social Security Number"
              maxLength={30}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="license"
            label="Driver's License"
            rules={[{ validator: idValidator }]}
          >
            <Input placeholder="Driver's License" maxLength={30} />
          </Form.Item>
        </Col>
        <Col span={6} sm={24} md={12} lg={6}>
          <Form.Item
            name="passportNumber"
            label="Passport Number"
            rules={[{ validator: idValidator }]}
          >
            <Input placeholder="Passport Number" maxLength={30} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12} sm={24} md={24} lg={12}>
          <Form.Item name="idNotes" label="Notes">
            <TextArea showCount maxLength={300} placeholder="Notes" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(IdentificationSection);
